<template>
  <div class="count-page">
    <el-descriptions class="margin-top" :column="3">
      <el-descriptions-item label="出库单号">{{outBoundOrder.order_id}}</el-descriptions-item>
      <el-descriptions-item label="出库仓库">{{outBoundOrder.warehouse}}</el-descriptions-item>
      <el-descriptions-item label="出库单类型">{{outBoundOrder.order_type}}</el-descriptions-item>
      <el-descriptions-item label="品名">{{outBoundOrder.goods_name}}</el-descriptions-item>
      <el-descriptions-item label="指示箱数">{{outBoundOrder.pack_qty}}</el-descriptions-item>
      <el-descriptions-item label="物品总数">{{outBoundOrder.item_qty}}</el-descriptions-item>
      <el-descriptions-item label="责任人">{{outBoundOrder.charge_user_id}}</el-descriptions-item>
      <el-descriptions-item label="领取时间">{{outBoundOrder.take_time}}</el-descriptions-item>
    </el-descriptions>

    <div style="margin:10px;border 1px #e5e5e5">
        <el-row class="margin-top">
            <el-col :span="6">国家：{{outBoundOrder.user_info.country_cn}}</el-col>
            <el-col :span="6">省份：{{outBoundOrder.user_info.state}}</el-col>
            <el-col :span="6">市：{{outBoundOrder.user_info.city}}</el-col>
        </el-row>
        <el-row class="margin-top">
            <el-col :span="24">地址：{{outBoundOrder.user_info.address}}</el-col>
        </el-row>
        <el-row class="margin-top">
            <el-col :span="6">客户名称：{{outBoundOrder.user_info.customer_name}}</el-col>
            <el-col :span="6">收件人：{{outBoundOrder.user_info.name}}</el-col>
            <el-col :span="6">电话：{{outBoundOrder.user_info.phone}}</el-col>
            <el-col :span="6">邮件：{{outBoundOrder.user_info.email}}</el-col>
        </el-row>
    </div>

    <div style="margin:10px;border 1px #e5e5e5">
        主运单号：<span style="color:blue">{{outBoundOrder.main_way_bill_no}}</span>
        <div v-if="outBoundOrder.way_bill_no" style="display: flex; flex-wrap: nowrap; ">
          <div v-for="billNo in outBoundOrder.way_bill_no" key="billNo" style="width: 200px; font-weight: bold; border: solid 1px #e5e5e5; text-align: center; padding: 3px; margin:3px; flex-shrink: 0;" >
            {{billNo}}
          </div>
        </div>
    </div>

    <h2 style="width: 100%;text-align: center">出库单明细</h2>
    <el-table :data="outBoundOrder.order_piece_list" style="width: 100%" stripe >
        <el-table-column type="expand">
            <template #default="scope">
              <div style="margin: 20px" v-if="scope.row.sn_flag">
                <text style="font-weight: bold">箱内序列号明细：</text>
                <div v-for="(sns,idx) in scope.row.packed_sn_list" :key="idx" style="display: flex;flex-wrap: nowrap;margin-left: 100px">
                  <div v-for="sn in sns" :key="sn" style="width: 200px; font-weight: bold; border: solid 1px #e5e5e5; text-align: center; padding: 3px; margin:3px; flex-shrink: 0;">
                    {{sn}}
                  </div>
                </div>
              </div>
              <div style="margin: 20px" v-else>
                <text style="font-weight: bold">非SN管控物料</text>
              </div>
            </template>
      </el-table-column>
      <el-table-column prop="package_no" label="指示箱号" width="200"></el-table-column>
      <el-table-column prop="item_code" label="物料代码" width="180"></el-table-column>
      <el-table-column prop="actual_pack_qty" align="center" label="已装箱数量" width="130"></el-table-column>
      <el-table-column prop="sn_flag" align="center" label="是否SN管控物料" width="130"></el-table-column>
      <el-table-column prop="item_name" label="物料描述"></el-table-column>
    </el-table>

    <div style="width: 100%;text-align: center;margin: 20px 0">
      <el-button v-if="outBoundOrder.main_way_bill_no === undefined" type="success" @click="openDialog">生成快递单号</el-button>
      <el-button v-else type="success" @click="openWindow">去打印面单</el-button>
      <el-button type="success" :loading="loading.submitPrintFinishBtn" @click="submitPrintFinish">贴单完成</el-button>
    </div>

    <el-dialog title="请选择寄件类型" v-model="wayBillDialog" width="30%" center>
      <div>
        <text style="color: red">*</text>
        寄件类型：
        <el-select style="width: 200px" v-model="sfExpressType" placeholder="请选择">
          <el-option
              v-for="item in sfExpressTypes"
              :key="item.value"
              :label="item.name"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="color: orange;font-size: 12px">温馨提示：包裹内若有“<text style="color: red;font-size: 16px">电池</text>”类产品，请选择“<text style="color: red;font-size: 16px">顺丰标快</text>”，一经提交后续不可自助修改</div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="wayBillDialog = false;sfExpressType = ''">取 消</el-button>
          <el-button type="primary" @click="submitCreateWayBillNo" :loading="loading.submitCreateWayBillNoBtn">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "DjiOutBoundOrderPick",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      wayBillDialog: false,
      sfExpressTypes: [],
      sfExpressType: '2',
      loading: {
        submitCreateWayBillNoBtn: false,
        submitPrintFinishBtn: false
      },
      itemSn: '',
      outBoundOrder: {}
    }
  },
  async created() {
    await this.getOutBoundOrder()
    this.getExpressType()
  },
  methods: {
    openDialog(){
      this.sfExpressType = '2'
      this.wayBillDialog = true
    },
    openWindow(){
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "task/WayBillNoRecord";
      windowObj.name = "快递面单明细";
      windowObj.parentData = this.outBoundOrder;
      windowObj.height = 800 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },
    async submitCreateWayBillNo(){
      if (this.sfExpressType === undefined || this.sfExpressType === ''){
        return this.$message.error("请选择寄件类型");
      }
      this.loading.submitCreateWayBillNoBtn = true;
      // eslint-disable-next-line no-unused-vars
      this.$http('outBoundService.submitCreateWayBillNo', {id: this.outBoundOrder.order_id, sfExpressType: this.sfExpressType}, false).then(data => {
        this.loading.submitCreateWayBillNoBtn = false;
        this.$message.success("生成快递单号成功");
        this.wayBillDialog = false;
        this.sfExpressType = '';
        this.getOutBoundOrder();
      }, errMsg => {
        this.loading.submitCreateWayBillNoBtn = false;
        return this.$message.error(errMsg);
      })
    },
    async submitPrintFinish(){
      this.loading.submitPrintFinishBtn = true;
      this.$http('outBoundService.submitPrintFinish', {id: this.outBoundOrder.order_id}, false).then(data => {
        this.loading.submitPrintFinishBtn = false;
        this.$message.success("提交成功");
        this.getOutBoundOrder();
      }, errMsg => {
        this.loading.submitPrintFinishBtn = false;
        return this.$message.error(errMsg);
      })
    },
    //获取出库单明细
    async getOutBoundOrder() {
      let data = await this.$http('outBoundService.getOutBoundOrder', {id: this.parentData.id,});
      this.outBoundOrder = data;
    },
    //获取顺丰寄件类型
    async getExpressType() {
      let data = await this.$http('outBoundService.getSfExpressTypes', {})
      this.sfExpressTypes = data
    }
  }
}
</script>

<style scoped lang="less">
.count-page{
  margin: 10px;
}
.margin-top{
  margin-top: 10px;
}
</style>